import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { LocalDate } from '../../../store/models';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { DirectivesModule } from '../../../common/directives/directives.module';
import { DatesWithDividerComponent } from '../../dates-with-divider/dates-with-divider.component';

@Component({
  selector: 'ui-info-field-dates-with-divider',
  imports: [
    CommonModule,
    MatFormFieldModule,
    TranslateModule,
    PipesModule,
    DirectivesModule,
    DatesWithDividerComponent,
  ],
  templateUrl: './info-field-dates-with-divider.component.html',
  styleUrls: ['./info-field-dates-with-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InfoFieldDatesWithDividerComponent {
  @Input() label: string;

  @Input() startDate: LocalDate;
  @Input() endDate: LocalDate;

  @Input() arrivalDeviation: string;
  @Input() departureDeviation: string;

  @Input() transitTime: string;
  @Input() transitDeviation: string;

  @Input() showWarningIcon: boolean;
  @Input() warningMessage: string;
}
